<template>
  <b-row>
    <b-col cols="12">
      <div>
        <form-wizard
          :subtitle="null"
          :title="null"
          back-button-text="Previous"
          class="mb-3"
          color="#7367F0"
          finish-button-text="Submit"
          shape="square"
          @on-complete="formSubmitted"
        >
          <!-- Resource Group tab -->
          <validation-observer
            ref="infoRules"
            tag="form"
          >
            <b-row>
              <b-col
                class="mb-2"
                cols="12"
              />
              <b-col md="12">
                <b-row
                  v-for="(designation, index) in designations"
                  :key="index"
                  class="mb-2"
                >
                  <b-col>
                    <b-form-group
                      label="Advisor"
                      label-for="Advisor"
                    >
                      <v-select
                        v-model="advisor"
                        :options="advisor"
                        :reduce="advisor => advisor.id"
                        label=" "
                        placeholder="Choose Advisor"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col md="12">
                    <b-form-group
                      label="Enter Designation"
                      label-for="Designation"
                    >
                      <validation-provider
                        #default="{ errors }"
                        name="Designation"
                        rules=""
                      >
                        <b-form-input
                          id="Designation"
                          v-model="designation.name"
                          type="number"
                          placeholder="Enter Designation"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </validation-observer>
        </form-wizard>
      </div>
    </b-col>
  </b-row>
</template>

<script>
import {
  BFormGroup, BFormInput, BRow, BCol,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import { heightTransition } from '@core/mixins/ui/transition'
import Ripple from 'vue-ripple-directive'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { FormWizard } from 'vue-form-wizard'

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    FormWizard,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    vSelect,
  },

  directives: {
    Ripple,
  },
  mixins: [heightTransition],
  data() {
    return {
      advisor: [],
      designations: [
        {
          name: null,
        },
      ],
    }
  },
  // props: ['inheritedSections'],
  methods: {
    notifyParent() {
      this.$emit('input', this.sections)
    },
    formSubmitted() {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: 'Form Submitted',
          icon: 'EditIcon',
          variant: 'success',
        },
      })
    },
    validationForm() {
      return new Promise((resolve, reject) => {
        this.$refs.accountRules.validate()
          .then(success => {
            if (success) {
              resolve(true)
            } else {
              reject()
            }
          })
      })
    },
    validationFormInfo() {
      return new Promise((resolve, reject) => {
        this.$refs.infoRules.validate()
          .then(success => {
            if (success) {
              resolve(true)
            } else {
              reject()
            }
          })
      })
    },
    validationFormAddress() {
      return new Promise((resolve, reject) => {
        this.$refs.addressRules.validate()
          .then(success => {
            if (success) {
              resolve(true)
            } else {
              reject()
            }
          })
      })
    },
    validationFormSocial() {
      return new Promise((resolve, reject) => {
        this.$refs.socialRules.validate()
          .then(success => {
            if (success) {
              resolve(true)
            } else {
              reject()
            }
          })
      })
    },
  },

}
</script>

<style lang="scss">
.vs__dropdown-menu{
  z-index: 1051 !important;
}
.repeater-form {
  overflow: hidden;
  transition: .35s height;
}
</style>
